
<script>
import { Pie, mixins } from 'vue-chartjs';
import * as ChartDataLabels from 'chartjs-plugin-labels'
const { reactiveProp } = mixins;

Chart.plugins.register(ChartDataLabels)

export default {
  name: 'pie',
  extends: Pie,
  mixins: [reactiveProp],
  mounted() {
    this.options = {
      responsive: true,
      maintainAspectRatio: true,
      tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
              var _data = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return _data;
            }
        }
      },
      plugins: {
        labels: {
          render: 'value',
          precision: 0,
          showZero: false,
          fontSize: 18,
          fontColor: '#fefefe',
          fontStyle: 'bold',
          textShadow: true,
          shadowBlur: 5,
          shadowOffsetX: -1,
          shadowOffsetY: 1,
          shadowColor: "#000",
          arc: false,
          overlap: true,
          showActualPercentages: false,
          outsidePadding: 4,
          textMargin: 6,
          position: 'border',
        }
      }
    }

    if (this.chartData) {
      this.renderChart(this.chartData || {}, this.options);
    }
  },
  watch: {
    chartData(newData) {
      if (this.chartData) {
        this.renderChart(this.chartData || {}, this.options);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/custom/Pie.vue